var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"rating-blocks",attrs:{"title":_vm.rating}},_vm._l((_vm.blocks),function(block,index){return _c('li',{key:(block + "-" + index),class:block})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }